import config from 'react-global-configuration';

const c = {
    auth0: {
        domain: process.env.REACT_APP_AUTH0_DOMAIN,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
        callbackURL: process.env.REACT_APP_AUTH0_CALLBACK_URL,
        loginURL: process.env.REACT_APP_AUTH0_LOGIN_URL,
        token: process.env.REACT_APP_AUTH0_TOKEN
    },
    re: {
        url: process.env.REACT_APP_RE_API_URL + process.env.REACT_APP_RE_APP_NAME + process.env.REACT_APP_RE_GLOBAL_VERSION, // https://sinexiar.com/smre/1.0/
        urlGlobal: process.env.REACT_APP_RE_API_URL + process.env.REACT_APP_RE_APP_NAME, // https://sinexiar.com/smre/
        domain: process.env.REACT_APP_RE_API_URL, // https://sinexiar.com/
        management: process.env.REACT_APP_RE_API_URL + process.env.REACT_APP_RE_APP_NAME + "management/" // https://sinexiar.com/smre/management/
    }
};

config.set(c);
export default config;